<template>
    <div class="raffle-header">
      <div class="raffle-title">{{ title }}</div>
      <div class="raffle-back">
        <i class="el-icon-arrow-left" @click="hide"></i>
      </div>
    </div>
  </template>
  <script>
  export default {
    props: {
      title: {
        typeof: String,
        default: "title",
      },
    },
    data() {
      return {};
    },
    methods: {
      hide() {
        this.$emit("hide");
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .raffle-header {
    height: 8%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    justify-content: center;
  
    .raffle-title {
      font-size: 0.36rem;
      color: #303030;
    }
  
    .raffle-back {
      position: absolute;
      display: flex;
      width: 100%;
      font-size: 0.48rem;
    }
  }
  </style>
  